import { render, staticRenderFns } from "./BaseSearchInGoogle.vue?vue&type=template&id=dc5f0356&scoped=true"
import script from "./BaseSearchInGoogle.vue?vue&type=script&lang=js"
export * from "./BaseSearchInGoogle.vue?vue&type=script&lang=js"
import style0 from "./BaseSearchInGoogle.vue?vue&type=style&index=0&id=dc5f0356&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5f0356",
  null
  
)

export default component.exports